import { useContext } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CallTopicContext } from '../../../contexts/CallTopicContext';
import { callTopics } from '../../../constants/CallTopics';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
const CallTopicTag = props => {
  const {
    callTopic
  } = props;
  const {
    selectedCallTopic,
    hoveredCallTopic,
    handleHoveredCallTopicToggle,
    handleSelectedCallTopicToggle
  } = useContext(CallTopicContext);
  const callTopicInfo = callTopic ? callTopics[callTopic] : null;
  const handleOnClick = () => {
    handleSelectedCallTopicToggle(callTopic);
  };
  const handleOnHover = () => {
    handleHoveredCallTopicToggle(callTopic);
  };
  if (!callTopicInfo) {
    return null;
  }
  const isHovered = hoveredCallTopic === callTopic;
  return /*#__PURE__*/_jsx("div", {
    onClick: handleOnClick,
    onMouseOver: handleOnHover,
    onMouseOut: handleOnHover,
    children: /*#__PURE__*/_jsx(View, {
      "data-test-id": 'callTopic-tag',
      "data-topic-selected": selectedCallTopic === callTopic,
      backgroundColor: isHovered ? 'fill-accent-neutral-hover' : 'fill-tertiary-default',
      borderWidth: "100",
      borderColor: "border-core-default",
      borderStyle: "solid",
      cursor: "pointer",
      paddingBlock: "100",
      paddingInline: "200",
      role: "button",
      children: /*#__PURE__*/_jsx(Text, {
        as: "small",
        color: isHovered ? 'text-core-on-fill-default' : 'text-core-default',
        children: /*#__PURE__*/_jsx("strong", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: callTopicInfo.translationKey
          })
        })
      })
    })
  });
};
export default CallTopicTag;